export const RETRY_CONFIG = {
  MAX_ATTEMPTS: 3,
  BASE_DELAY_MS: 2000,
};

export const isRetryableError = error => {
  if (!error.response) return true;
  return error.response.status >= 500;
};

export const getRetryDelay = attempt => {
  return 2 ** attempt * RETRY_CONFIG.BASE_DELAY_MS;
};

export const delay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });
